import React from 'react';
import Button from '@99designs/frontend-components/components/Button/Button';
import { trackEvent } from '@99designs/tracking';
interface Props {
    link: string;
    buttonColor: string;
    children: React.ReactNode;
    categoryKey: string;
    cta_location: string;
}

export default function CTAButton({
    link,
    buttonColor,
    children,
    categoryKey,
    cta_location,
}: Props) {
    return (
        <Button
            variations={['jumbo', 'primary']}
            href={link}
            style={{
                backgroundColor: buttonColor,
                borderColor: buttonColor,
            }}
            onClick={() => {
                trackEvent('Clicked CTA on Product page', {
                    cta_location: cta_location,
                    category: categoryKey,
                });
            }}
        >
            {children}
        </Button>
    );
}
